<era-pane>
  <h5 class="small-caps"
      i18n>Bluetooth</h5>
  <form [formGroup]="bluetoothForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input rounded-3"
               role="switch"
               formControlName="bluetoothEnabled"
               id="bluetoothEnabled" />
        <label class="from-check-label"
               for="bluetoothEnabled">Turn Bluetooth {{ (bluetoothEnabled.valueChanges | async) ? 'On' : 'Off'
          }}</label>
      </div>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!bluetoothForm.valid">Submit</button>
  </form>
</era-pane>